import { Flex, Text, xcss } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';
import { messages } from '@databases/intl/messages';
import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';
import styled from 'styled-components';

const OverlayContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  background: radial-gradient(
    ellipse 50% 100% at 50% 50%,
    ${token('elevation.surface', '#FFFFFF')} 0%,
    ${token('elevation.surface', '#FFFFFF')}CC 60%,
    ${token('elevation.surface', '#FFFFFF')}00 100%
  );
  border-radius: 0 0 3px 3px;
`;

const contentStyles = xcss({
  gap: 'space.100',
});

const FilterLoadingOverlay: FunctionComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <OverlayContainer data-testid="filter-loading-overlay">
      <Flex alignItems="center" xcss={contentStyles}>
        <Spinner size="small" />
        <Text color="color.text" size="medium">
          {formatMessage(messages['table-layout.filtering-entries'])}
        </Text>
      </Flex>
    </OverlayContainer>
  );
};

export default FilterLoadingOverlay;
